import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface AccordionProps {
  question: string;
  answer: string;
}
export function Accordion({
  question,
  answer
}: AccordionProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-dark-border bg-dark-card rounded-lg overflow-hidden mb-4" data-id="element-335">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between p-4 sm:p-5 text-left focus:outline-none" data-id="element-336">
        <span className="font-heading font-semibold text-base sm:text-lg text-white pr-3 sm:pr-4 leading-tight" data-id="element-337">
          {question}
        </span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.2
      }} className="flex-shrink-0 text-gold" data-id="element-338">
          <ChevronDown size={20} className="sm:w-6 sm:h-6" data-id="element-339" />
        </motion.div>
      </button>

      <AnimatePresence data-id="element-340">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} data-id="element-341">
            <div className="p-4 sm:p-5 pt-0 text-sm sm:text-base text-gray-300 leading-relaxed border-t border-dark-border/50 mt-2" data-id="element-342">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}